module.exports = __webpack_public_path__ + "f273fa27f0623241b573242e866795cd.svg";


//////////////////
// WEBPACK FOOTER
// ./components/home/sample/up.svg
// module id = 621
// module chunks = 0